var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCarHeader = function SvgCarHeader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#121212",
    fillRule: "evenodd",
    d: "M12.18 13.259H7.422v-1.282h4.756z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#121212",
    fillRule: "evenodd",
    d: "M13.757 11.677a.938.938 0 1 0 0 1.875.938.938 0 0 0 0-1.875m-2.22.938a2.22 2.22 0 1 1 4.44 0 2.22 2.22 0 0 1-4.44 0M5.844 11.645a.938.938 0 1 0 0 1.876.938.938 0 0 0 0-1.876m-2.22.938a2.22 2.22 0 1 1 4.44 0 2.22 2.22 0 0 1-4.44 0",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#121212",
    fillRule: "evenodd",
    d: "M10.992 6.635a2.3 2.3 0 0 0-.91-.185H7.138a1.45 1.45 0 0 0-1.19.619l-.001.001L4.76 8.748c-.247.35-.61.599-1.025.703l-.004.001-.582.138a.26.26 0 0 0-.199.284v.004l.196 1.897a.23.23 0 0 0 .228.2h.617v1.281h-.62a1.514 1.514 0 0 1-1.497-1.327l-.001-.006-.197-1.906a1.543 1.543 0 0 1 1.175-1.674l.574-.136c.116-.03.218-.1.287-.198l1.186-1.676A2.73 2.73 0 0 1 7.14 5.168h2.94a3.58 3.58 0 0 1 2.604 1.11v.002l1.819 1.927 2.284.414a1.887 1.887 0 0 1 1.488 2.325l-.235.98-.002.005a1.79 1.79 0 0 1-1.74 1.345h-1.038v-1.282h1.043a.506.506 0 0 0 .492-.377l.236-.982.002-.006a.605.605 0 0 0-.476-.747l-2.698-.489-2.103-2.23h-.001a2.3 2.3 0 0 0-.762-.528",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#121212",
    fillRule: "evenodd",
    d: "m3.866 8.09 10.327.078-.01 1.282-10.326-.078z",
    clipRule: "evenodd"
  })));
};
export default SvgCarHeader;